export default __webpack_public_path__ + "static/media/jnh1.d531996c.jpg";